const messagePlaceholders = {
  message: {
    text: 'Enter a message',
    title: 'Enter Title',
    description: 'Enter Description',
    subtitle: 'Enter Subtitle',
    label: 'List Header',
    section: 'Enter Section Title',
    contact: 'Contact Name',
    location: 'Button Title',
    document: 'Enter Text'
  },
  button: {
    title: 'Button',
    title_by_channel: {
      googlercs: 'Suggestion'
    },
    description: 'Enter Button Description',
    payload: 'Enter Custom Text'
  }
};

const botBuilderNodes = {
  starting: {
    "img_url": "Trigger.svg",
    "text": "Starting Point",
    "placeholder_text": messagePlaceholders,
    "template_type": "starting",
    "description": "For Internal use only",
  },
  normalchat: {
    "img_url": "normal-text.svg",
    "text": "Text message",
    "placeholder_text": messagePlaceholders,
    "template_type": "normalchat",
    "active": true,
    "input": 1,
    "output": 1,
    "enabled_channels": [
      "whatsapp", "googlercs", "sms"
    ],
    "validation_rules": {
      "text": {
        "maxlength": {
          "whatsapp": 1000,
          "sms": 2000,
          "googlercs": 3000
        }
      },
    },
    "tooltip": {
      "whatsapp": {
        "image": "text.png",
        "description": "A Text Message allows you to add text (even emojis) to your message, along with variables such as User name, Agent name, etc.",
        "link": ""
      },
      "googlercs": {
        "image": "text.png",
        "description": "A Text Message allows you to add text (even emojis) to your message, along with variables such as User name, Agent name, etc.",
        "link": ""
      },
      "sms": {
        "image": "text.png",
        "description": "A Text Message allows you to add text (even emojis) to your message, along with variables such as User name, Agent name, etc.",
        "link": ""
      }
    }
  },
  quickreplies: {
    "img_url": "quick-reply.svg",
    "text": "Quick replies",
    "placeholder_text": messagePlaceholders,
    "template_type": "quickreplies", // Rich card for RCS
    "active": true,
    "input": 1,
    "output": 1,
    "enabled_channels": [
      "whatsapp", "googlercs"
    ],
    "validation_rules": {
      "text": {
        "maxlength": {
          "whatsapp": 1000,
          "googlercs": 3000
        }
      },
      "button": {
        "max_quantity": {
          "whatsapp": 3,
          "googlercs": 11
        },
        "button_types_allowed": {
          "whatsapp": ["postback"],
          "googlercs": ["webview", "postback"]
        },
        "button": {
          "title_length": {
            "whatsapp": 20,
            "googlercs": 25
          },
          "subtitle_length": {
            
          }
        }
      },
    },
    "wait_for_user_input": true,
    "info_banner": {
      "whatsapp": {
        "text": 'You can add upto 3 Quick Reply buttons'
      },
      "googlercs": {
        "text": 'You can add upto 11 Quick Reply buttons'
      }
    },
    "tooltip": {
      "whatsapp": {
        "image": "quick-replies.png",
        "description": "In Quick Replies, you have button options below your text message, which allows your customers to choose an option & jump to their requirements.",
        "link": ""
      },
      "googlercs": {
        "image": "quick-replies.png",
        "description": "In Quick Replies, you have button options below your text message, which allows your customers to choose an option & jump to their requirements.",
        "link": ""
      }
    }
  },
  buttonreply: {
    "img_url": "button-message.svg",
    "text": "Button message",
    "placeholder_text": messagePlaceholders,
    "template_type": "buttonreply",
    "active": false,
    "input": 1,
    "output": 1,
    "enabled_channels": [],
    "validation_rules": {
      "text": {
        "maxlength": {
          "whatsapp": 1000,
          "googlercs": 3000
        }
      },
      "button": {
        "max_quantity": {
          "whatsapp": 3,
          "googlercs": 3
        },
        "button_types_allowed": {
          "whatsapp": ["webview", "postback"],
          "googlercs": ["webview", "postback"]
        },
        "button": {
          "maxlength": {
            "whatsapp": 20,
            "googlercs": 25
          }
        }
      },
    },
    "tooltip": {
      "whatsapp": {
        "image": "button-message.png",
        "description": "In Button message, you have button options below your text message template to let your users proceed with the information provided in the text template.",
        "link": ""
      }
    }
  },
  carousel: {
    "img_url": "cards-carousel.svg",
    "text": "Carousel",
    "placeholder_text": messagePlaceholders,
    "template_type": "carousel", //rich card for rcs
    "active": true,
    "input": 1,
    "output": 1,
    "enabled_channels": [
      "googlercs"
    ],
    "validation_rules": {
      "element": {
        "max_quantity": {
          "googlercs": 10
        },
        "element_info": {
          "title_length": {
            "googlercs": 200
          },
          "subtitle_length": {
            "googlercs": 2000
          }
        }
      },
      "button": {
        "max_quantity": {
          "googlercs": 4
        },
        "button_types_allowed": {
          "googlercs": ["webview", "postback"]
        },
        "button": {
          "maxlength": {
            "googlercs": 25
          }
        }
      },
      "suggested_replies": {
        "max_quantity": {
          "googlercs": 11
        },
        "button_types_allowed": {
          "googlercs": ["webview", "postback"]
        },
        "button": {
          "maxlength": {
            "googlercs": 25
          }
        }
      },
    },
    "info_banner": {
      "googlercs": {
        "text": '<ul class="info-text ion-no-margin" style="padding-left: 15px;"><li class="title">Title and description are required, media and buttons are optional</li><li class="title">Max file size 100MB per media </li><li class="title">Supported media formats - Image (jpeg/jpg, gif, png) Video (m4v, mp4, mpeg, mpeg-4, webm) </li></ul>'
      }
    },
    "tooltip": {
      "googlercs": {
        "image": "card.png",
        "description": "In Carousel, you can send multiple Rich Cards in a scrollable format.",
        "link": ""
      }
    }
  },
  carouselWhatsapp: {
    "img_url": "card-only.svg",
    "text": "Card Message",
    "placeholder_text": messagePlaceholders,
    "template_type": "carousel", //rich card for rcs
    "active": true,
    "input": 1,
    "output": 1,
    "enabled_channels": [
      "whatsapp"
    ],
    "validation_rules": {
      "element": {
        "max_quantity": {
          "whatsapp": 1
        },
        "element_info": {
          "title_length": {
            "whatsapp": 20
          },
          "subtitle_length": {
            "whatsapp": 1024
          }
        }
      },
      "button": {
        "max_quantity": {
          "whatsapp": 0
        },
        "button_types_allowed": {
          "whatsapp": ["postback"]
        },
        "button": {
          "maxlength": {
            "whatsapp": 20
          }
        }
      },
      "suggested_replies": {
        "max_quantity": {
          "whatsapp": 0
        },
        "button_types_allowed": {
          "whatsapp": ["postback"]
        },
        "button": {
          "maxlength": {
            "whatsapp": 20
          }
        }
      },
    },
    "info_banner": {
      "whatsapp": {
        "text": '<ul class="info-text ion-no-margin" style="padding-left: 15px;"><li class="title">Max. file size 5 MB (.jpg or .png only)</li><li class="title">Title Text - Max. 20 characters.</li><li class="title">Subtitle Text - Max. 1024 characters.</li></ul>'
      }
    },
    "tooltip": {
      "whatsapp": {
        "image": "card.png",
        "description": "In Card message, you can add an Image, Title & Subtitle for a single card.",
        "link": ""
      }
    }
  },
  interactivecarousel: {
    "img_url": "cards-carousel.svg",
    "text": "Interactive Media Carousel",
    "placeholder_text": messagePlaceholders,
    "template_type": "interactivecarousel",
    "default_message": "",
    "active": true,
    "input": 1,
    "output": 1,
    "enabled_channels": ["whatsapp"],
    "info_banner": {
      "whatsapp": {
        "text": '<ul class="info-text ion-no-margin" style="padding-left: 15px;"><li class="title">Add 2 to 10 image or video cards.</li><li class="title">Every card must use the same button type and button count.</li><li class="title">Images: JPG, JPEG or PNG up to 5 MB. Videos: MP4 up to 16 MB.</li></ul>'
      }
    },
    "tooltip": {
      "whatsapp": {
        "image": "card.png",
        "description": "Send interactive media cards during an active WhatsApp conversation.",
        "link": "https://developers.facebook.com/documentation/business-messaging/whatsapp/messages/interactive-media-carousel-messages/"
      }
    }
  },
  richcard: {
    "img_url": "card-only.svg",
    "text": "Rich Card",
    "placeholder_text": messagePlaceholders,
    "template_type": "richcard", //rich card for rcs
    "active": true,
    "input": 1,
    "output": 1,
    "enabled_channels": [
      "googlercs"
    ],
    "validation_rules": {
      "element": {
        "max_quantity": {
          "whatsapp": 1,
          "googlercs": 10
        },
        "element_info": {
          "title_length": {
            "whatsapp": 20,
            "googlercs": 200
          },
          "subtitle_length": {
            "whatsapp": 1024,
            "googlercs": 2000
          }
        }
      },
      "button": {
        "max_quantity": {
          "whatsapp": 0,
          "googlercs": 4
        },
        "button_types_allowed": {
          "whatsapp": ["postback"],
          "googlercs": ["webview", "postback"]
        },
        "button": {
          "maxlength": {
            "whatsapp": 20,
            "googlercs": 25
          }
        }
      },
      "suggested_replies": {
        "max_quantity": {
          "whatsapp": 0,
          "googlercs": 11
        },
        "button_types_allowed": {
          "whatsapp": ["postback"],
          "googlercs": ["webview", "postback"]
        },
        "button": {
          "maxlength": {
            "whatsapp": 20,
            "googlercs": 25
          }
        }
      },
    },
    "info_banner": {
      "whatsapp": {
        "text": ''
      },
      "googlercs": {
        "text": '<ul class="info-text ion-no-margin" style="padding-left: 15px;"><li class="title">Title and description are required, media and buttons are optional</li><li class="title">Max file size 100MB per media </li><li class="title">Supported media formats - Image (jpeg/jpg, gif, png) Video (m4v, mp4, mpeg, mpeg-4, webm) </li></ul>'
      }
    },
    "tooltip": {
      "googlercs": {
        "image": "rich-card.png",
        "description": "A Rich Card lets you send a message with an image, title, description & buttons. You can choose between vertical and horizontal layouts.",
        "link": ""
      }
    }
  },
  quickcarousel: {
    "img_url": "cards-carousel.svg",
    "text": "Carousel with quick replies",
    "placeholder_text": messagePlaceholders,
    "template_type": "quickcarousel",
    "active": true,
    "input": 1,
    "output": 1,
    "enabled_channels": [
    ],
    "validation_rules": {
      "element": {
        "max_quantity": {
          "googlercs": 10
        },
        "element_info": {
          "title_length": {
            "googlercs": 60
          },
          "subtitle_length": {
            "googlercs": 80
          }
        }
      },
      "button": {
        "max_quantity": {
          "googlercs": 3
        },
        "button_types_allowed": {
          "googlercs": ["webview", "postback"]
        },
        "button": {
          "maxlength": {
            "googlercs": 20
          }
        }
      },
    }
  },
  cancelled: {
    "img_url": "image-only.svg",
    "text": "Image",
    "placeholder_text": messagePlaceholders,
    "template_type": "cancelled",
    "active": true,
    "input": 1,
    "output": 1,
    "enabled_channels": [
      "whatsapp", "googlercs"
    ],
    "info_banner": {
      "whatsapp": {
        "text": 'Max file size 5 MB (.jpg or .png only)'
      },
      "googlercs": {
        "text": 'Max file size 100 MB (.jpg, .png or .gif only)'
      }
    },
    "tooltip": {
      "whatsapp": {
        "image": "image.png",
        "description": "In an Image message type you can either upload your image or add a link to the image.",
        "link": ""
      },
      "googlercs": {
        "image": "image.png",
        "description": "In an Image message type you can either upload your image or add a link to the image.",
        "link": ""
      }
    }
  },
  /* imagereply: {
    "img_url": "image-only.svg",
    "text": "Image with Buttons message",
    "placeholder_text": messagePlaceholders,
    "template_type": "imagereply",
    "active": true,
    "input": 1,
    "output": 1,
    "enabled_channels": [
      "googlercs"
    ],
    "validation_rules": {
      "text": {
        "maxlength": {
          "googlercs": 640
        },
        "maxsize_in_mbs": {
          "googlercs": 25
        }
      },
      "button": {
        "max_quantity": {
          "googlercs": 1
        },
        "button_types_allowed": {
          "googlercs": ["webview", "postback"]
        },
        "button": {
          "maxlength": {
            "googlercs": 20
          }
        }
      }
    }
  }, */
  videoreply: {
    "img_url": "video-only.svg",
    "text": "Video",
    "placeholder_text": messagePlaceholders,
    "template_type": "videoreply",
    "active": true,
    "input": 1,
    "output": 1,
    "enabled_channels": [
      "whatsapp", "googlercs"
    ],
    "info_banner": {
      "whatsapp": {
        "text": 'Max file size 16 MB (.mp4 only)'
      },
      "googlercs": {
        "text": 'Max file size 100 MB (.mp4, .mpeg4, .m4v or .webm only)'
      }
    },
    "tooltip": {
      "whatsapp": {
        "image": "video.png",
        "description": "In a video message you can upload your video just by clicking on the upload option and selecting the video file.",
        "link": ""
      },
      "googlercs": {
        "image": "video.png",
        "description": "In a video message you can upload your video just by clicking on the upload option and selecting the video file.",
        "link": ""
      }
    }
  },
  listreply: {
    "img_url": "list-message.svg",
    "text": "List message",
    "placeholder_text": messagePlaceholders,
    "template_type": "listreply",
    "active": true,
    "input": 1,
    "output": 1,
    "enabled_channels": [
      "whatsapp"
    ],
    "validation_rules": {
      "text": {
        "maxlength": {
          "whatsapp": 1000
        }
      },
      "element": {
        "max_quantity": {
          "whatsapp": 10
        },
        "min_quantity": {
          "whatsapp": 2
        }
      },
      "element_info": {
        "title_length": {
          "whatsapp": 24
        },
        "subtitle_length": {
          "whatsapp": 60
        }
      },
      "button": {
        "max_quantity": {
          "whatsapp": 1
        },
        "button_types_allowed": {
          "whatsapp": ["postback"]
        },
        "button": {
          "title_length": {
            "whatsapp": 23
          },
          "subtitle_length": {
            "whatsapp": 60
          },
          "listOpenerButtonTitle_length": {
            "whatsapp": 20
          }
        }
      },
    },
    "tooltip": {
      "whatsapp": {
        "image": "listreply.png",
        "description": "In List message type, you can send text message along with additional sections to your message type, i.e Expanded list view.",
        "link": ""
      }
    },
    "wait_for_user_input": true
  },
  contact: {
    "img_url": "contact.svg",
    "text": "Contact",
    "placeholder_text": messagePlaceholders,
    "template_type": "contact",
    "active": true,
    "input": 1,
    "output": 1,
    "enabled_channels": [
      "whatsapp"
    ],
    "tooltip": {
      "whatsapp": {
        "image": "contact.png",
        "description": "In the Contact message type you can share a contact’s name and number in your message.",
        "link": ""
      }
    }
  },
  location: {
    "img_url": "location.svg",
    "text": "Location",
    "placeholder_text": messagePlaceholders,
    "template_type": "location",
    "active": true,
    "input": 1,
    "output": 1,
    "enabled_channels": [
      "whatsapp"
    ],
    "tooltip": {
      "whatsapp": {
        "image": "location.png",
        "description": "In a Location message, you can share your store location for the region or a pickup address details with your customer.",
        "link": ""
      }
    }
  },
  document: {
    "img_url": "file-only.svg",
    "text": "File",
    "placeholder_text": messagePlaceholders,
    "template_type": "document",
    "active": true,
    "input": 1,
    "output": 1,
    "enabled_channels": [
      "whatsapp", "googlercs"
    ],
    "info_banner": {
      "whatsapp": {
        "text": 'Max file size 100MB (.pdf, .doc, .docx, .xls, .ppt, .pptx or .txt only)'
      },
      "googlercs": {
        "text": 'Max file size 100 MB (.pdf only)'
      }
    },
    "tooltip": {
      "whatsapp": {
        "image": "file.png",
        "description": "In a File message type, you can upload & share a file (e.g. Store brochure), directly with your customers in conversation flows.",
        "link": ""
      },
      "googlercs": {
        "image": "file.png",
        "description": "In a File message type, you can upload & share a file (e.g. Store brochure), directly with your customers in conversation flows.",
        "link": ""
      }
    }
  },
  botwhatsapptemplate: {
    "img_url": "whatsapp-message-template.svg",
    "text": "WhatsApp Template",
    "placeholder_text": messagePlaceholders,
    "template_type": "botwhatsapptemplate",
    "active": true,
    "input": 1,
    "output": 1,
    "enabled_channels": [
      "whatsapp"
    ],
    "tooltip": {
      "whatsapp": {
        "image": "message-template.png",
        "description": "A WhatsApp template is a channel-specific message type, which is supported only for WhatsApp. Make sure you have created at least a single WhatsApp template.",
        "link": ""
      }
    }
  },
}

const nodeConditions = {
  "always_true": {
    "active": true,
    "prod_active": true,
    "ui_name": "Always true",
    "action_name": "always true",
    "supported_template_types": "normalchat,quickreplies,buttonmessage,carousel,richcard,image,video,document,listreply,contact,location,cancelled,videoreply,botwhatsapptemplate,interactivecarousel",
    "Condition": [
      {
        "label": "Always true",
        "condition": "true == true",
        "key": "always_true"
      }
    ],
    "fallback_match_string": "true == true",
    "key": "always_true"
  },
  "validate_name_true": {
    "active": true,
    "prod_active": true,
    "ui_name": "Check if name is valid",
    "action_name": "name is valid",
    "supported_template_types": "normalchat",
    "Condition": [
      {
        "label": "Check if name is valid",
        "condition": "func check_name_cd() == true",
        "key": "validate_name_true"
      }
    ],
    "Operation": [
      {
        "label": "Set user's name as current entered text",
        "operation": "func set_user_name_op()",
        "key": "set_user_name_op"
      },
      {
        "label": "Save user's name to refer in next section",
        "operation": "flow.pastsave = buyer.name",
        "key": "set_flow_pastsave_to_buyer_name"
      }
    ],
    "fallback_match_string": "func check_name_cd() == true",
    "key": "validate_name_true"
  },
  "validate_name_false": {
    "active": true,
    "prod_active": true,
    "ui_name": "Check if name is invalid",
    "action_name": "name is invalid",
    "supported_template_types": "normalchat",
    "Condition": [
      {
        "label": "Check if name is invalid",
        "condition": "func check_name_cd() == false",
        "key": "validate_name_false"
      }
    ],
    "fallback_match_string": "func check_name_cd() == false",
    "key": "validate_name_false"
  },
  "validate_email_true": {
      "active": true,
      "prod_active": true,
      "ui_name": "Check if email is valid",
      "action_name": "email is valid",
      "supported_template_types": "normalchat",
      "Condition": [
          {
              "label": "Check if email is valid",
              "condition": "func check_email_cd() != func dostr(invalid)",
              "key": "validate_email_true"
          }
      ],
      "Operation": [
          {
              "label": "Set user's email to the text entered",
              "operation": "buyer.email = flow.check_email_result",
              "key": "set_buyer_email"
          },
          {
              "label": "Save user's email to refer in next section",
              "operation": "flow.pastsave = flow.check_email_result",
              "key": "set_flow_pastsave_to_email"
          }
      ],
      "fallback_match_string": "func check_email_cd() != func dostr(invalid)",
      "key": "validate_email_true"
  },
  "validate_email_false": {
      "active": true,
      "prod_active": true,
      "ui_name": "Check if email is invalid",
      "action_name": "email is invalid",
      "supported_template_types": "normalchat",
      "Condition": [
          {
              "label": "Check if email is invalid",
              "condition": "func check_email_cd() == func dostr(invalid)",
              "key": "validate_email_false"
          }
      ],
      "fallback_match_string": "func check_email_cd() == func dostr(invalid)",
      "key": "validate_email_false"
  },
  "validate_mobilenumber_true": {
      "active": false,
      "prod_active": false,
      "ui_name": "Check if mobile number is valid",
      "action_name": "mobile number is valid",
      "supported_template_types": "normalchat",
      "Condition": [
          {
              "label": "Check if mobile number is valid",
              "condition": "func check_mobile_cd() != func dostr(invalid)",
              "key": "validate_mobilenumber_true"
          }
      ],
      "Operation": [
          {
              "label": "Save user's mobile to refer in next section",
              "operation": "flow.pastsave = func check_mobile_cd()",
              "key": "set_flow_pastsave_to_mobile"
          }
      ],
      "fallback_match_string": "func check_mobile_cd() != func dostr(invalid)",
      "key": "validate_mobilenumber_true"
  },
  /* "validate_mobilenumber_false": {
      "active": false,
      "prod_active": false,
      "ui_name": "Check if mobile number is invalid",
      "action_name": "mobile number is invalid",
      "supported_template_types": "normalchat",
      "fallback_match_string": "",
      "key": "validate_mobilenumber_false"
  }, */
  "validate_saleschannel_true": {
      "active": false,
      "prod_active": false,
      "ui_name": "Check if any particular channel is activated",
      "action_name": "channel is activated",
      "supported_template_types": "normalchat",
      "Condition": [
          {
              "label": "Check if channel is active",
              "condition": "func check_saleschannel_cd(bot) == true",
              "key": "validate_saleschannel_true"
          }
      ],
      "fallback_match_string": "func check_saleschannel_cd(",
      "key": "validate_saleschannel_true"
  },
  "validate_saleschannel_false": {
      "active": false,
      "prod_active": false,
      "ui_name": "Check if any particular channel is not activated",
      "action_name": "channel is not activated",
      "supported_template_types": "normalchat",
      "Condition": [
          {
              "label": "Check if channel is not active",
              "condition": "func check_saleschannel_cd(bot) == false",
              "key": "validate_saleschannel_false"
          }
      ],
      "fallback_match_string": "func check_saleschannel_cd(",
      "key": "validate_saleschannel_false"
  },
  "check_user_input_condition": {
      "active": true,
      "prod_active": true,
      "ui_name": "Check user input",
      "action_name": "check user input",
      "supported_template_types": "normalchat,quickreplies,buttonmessage,carousel,richcard,listreply,botwhatsapptemplate,interactivecarousel",
      "Condition": [
          {
              "label": "Check user input",
              "condition": "USER_TYPED_INPUT in text",
              "key": "check_user_input_condition"
          }
      ],
      "input_fields_required": [
          {
              "name": "USER_TYPED_INPUT",
              "field_type": "text",
              "identifier": "user_typed_input",
              "label": "Enter text what user may enter or select",
              "trim_part1": "",
              "trim_part2": " in text"
          }
      ],
      "fallback_match_string": " in text",
      "key": "check_user_input_condition"
  },
  "check_user_input_multiple_condition": {
      "active": false,
      "prod_active": false,
      "ui_name": "Check user input (multiple)",
      "action_name": "check user input (multiple)",
      "supported_template_types": "normalchat,quickreplies,buttonmessage,carousel,richcard,listreply,botwhatsapptemplate",
      "Condition": [
          {
              "label": "Check user input (multiple)",
              "condition": "[USER_TYPED_INPUT] in text",
              "key": "check_user_input_multiple_condition"
          }
      ],
      "input_fields_required": [
          {
              "name": "USER_TYPED_INPUT",
              "field_type": "text",
              "identifier": "user_typed_input",
              "label": "Enter text what user may enter or select",
              "trim_part1": "[",
              "trim_part2": "] in text"
          }
      ],
      "fallback_match_string": "] in text",
      "key": "check_user_input_multiple_condition"
  },
  "get_if_order_variable_exists": {
      "active": true,
      "prod_active": true,
      "ui_name": "Check if bot variable has expected value",
      "action_name": "check if bot variable has expected value",
      "supported_template_types": "normalchat,quickreplies,buttonmessage,carousel,richcard,listreply,botwhatsapptemplate,interactivecarousel",
      "Condition": [
          {
              "label": "Check if bot variable has expected value",
              "condition": "func getordervar(VARIABLE_NAME) == INPUT_VALUE",
              "key": "get_if_order_variable_exists"
          }
      ],
      "input_fields_required": [
          {
              "name": "VARIABLE_NAME",
              "field_type": "bot_variable",
              "identifier": "variable_name",
              "label": "Variable name",
              "trim_part1": "func getordervar(",
              "trim_part2": ") == "
          },
          {
              "name": "INPUT_VALUE",
              "field_type": "text",
              "identifier": "input_value",
              "label": "Value",
              "trim_part1": ") == ",
              "trim_part2": ""
          }
      ],
      "fallback_match_string": "func getordervar(",
      "key": "get_if_order_variable_exists"
  },
  "check_custom_field_value": {
      "active": true,
      "prod_active": true,
      "ui_name": "Check if custom field and its value matches",
      "action_name": "check if custom field and its value matches",
      "supported_template_types": "normalchat,quickreplies,buttonmessage,carousel,richcard,image,video,document,listreply,contact,location,cancelled,videoreply,botwhatsapptemplate,interactivecarousel",
      "Condition": [
          {
              "label": "Check if custom field and its value matches",
              "condition": "func check_customfield_cd(FIELD_NAME) == FIELD_VALUE",
              "key": "check_custom_field_value"
          }
      ],
      "input_fields_required": [
          {
              "name": "FIELD_NAME",
              "field_type": "field_name",
              "identifier": "field_name",
              "label": "Field name",
              "trim_part1": "func check_customfield_cd(",
              "trim_part2": ") == "
          },
          {
              "name": "FIELD_VALUE",
              "field_type": "text",
              "identifier": "field_value",
              "label": "Field value",
              "trim_part1": ") == ",
              "trim_part2": ""
          }
      ],
      "fallback_match_string": "func check_customfield_cd(",
      "key": "check_custom_field_value"
  },
  "check_custom_field_does_not_exists": {
      "active": true,
      "prod_active": true,
      "ui_name": "Check if CRM field does not exists for the customer",
      "action_name": "CRM field does not exists",
      "supported_template_types": "normalchat,quickreplies,buttonmessage,carousel,richcard,image,video,document,listreply,contact,location,cancelled,videoreply,botwhatsapptemplate,interactivecarousel",
      "Condition": [
          {
              "label": "CRM field does not exists",
              "condition": "func has_customfield_cd(FIELD_NAME) == false",
              "key": "check_custom_field_does_not_exists"
          }
      ],
      "input_fields_required": [
          {
              "name": "FIELD_NAME",
              "field_type": "field_name",
              "identifier": "field_name",
              "label": "Enter a field name",
              "trim_part1": "func has_customfield_cd(",
              "trim_part2": ") == false"
          }
      ],
      "fallback_match_string": "func has_customfield_cd(",
      "key": "check_custom_field_does_not_exists"
  },
  "check_if_coupon_has_been_distributed_to_this_user": {
    "active": true,
    "prod_active": true,
    "ui_name": "Check if the user is going through this bot again (repeated user)",
    "action_name": "the user is going through this bot again",
    "supported_template_types": "normalchat,quickreplies,buttonmessage,carousel,richcard,image,video,document,listreply,contact,location,cancelled,videoreply,botwhatsapptemplate,interactivecarousel",
    "Condition": [
      {
        "label": "Check if the user is going through this bot again (repeated user)",
        "condition": "func have_paid_order_cd(BOT_TRIGGER) == true",
        "key": "check_if_coupon_has_been_distributed_to_this_user"
      }
    ],
    "input_fields_required": [
      {
        "name": "BOT_TRIGGER",
        "field_type": "bot_link_all",
        "identifier": "bot_trigger",
        "label": "Select bot",
        "trim_part1": "func have_paid_order_cd(",
        "trim_part2": ") == true"
      }
    ],
    "fallback_match_string": "func have_paid_order_cd(",
    "key": "check_if_coupon_has_been_distributed_to_this_user"
  },
  "generating_coupon_code": {
      "active": false,
      "prod_active": false,
      "ui_name": "Generating a coupon code",
      "action_name": "generating a coupon code",
      "supported_template_types": "normalchat,quickreplies,buttonmessage,carousel,richcard,image,video,document,listreply,contact,location,cancelled,videoreply,botwhatsapptemplate",
      "Condition": [
          {
              "label": "Starting the coupon code generation process",
              "condition": "func lock_transaction_cd() == true",
              "key": "generating_coupon_code_lock_transaction"
          },
          {
              "label": "Checking if coupon code distribution is active",
              "condition": "func check_has_coupon_code_cd() == true",
              "key": "generating_coupon_code_check"
          }
      ],
      "Operation": [
          {
              "label": "Assigning a coupon code to this user",
              "operation": "func set_order_coupon()",
              "key": "set_order_coupon"
          },
          {
              "label": "Creating a QR code image for the coupon code",
              "operation": "func create_qr_op(fromstring=true)",
              "key": "create_qr_op"
          },
          {
              "label": "Ending the coupon code generation process",
              "operation": "func unlock_transaction_op()",
              "key": "unlock_transaction_op"
          }
      ],
      "fallback_match_string": "func lock_transaction_cd() == true",
      "key": "generating_coupon_code"
  },
  "check_if_coupon_code_distribution_is_active": {
      "active": false,
      "prod_active": false,
      "ui_name": "Check if coupon code distribution is active",
      "action_name": "coupon code distribution is active",
      "supported_template_types": "normalchat,quickreplies,buttonmessage,carousel,richcard,image,video,document,listreply,contact,location,cancelled,videoreply,botwhatsapptemplate",
      "Condition": [
          {
              "label": "Check if coupon code distribution is active",
              "condition": "func check_has_coupon_code_cd() == true",
              "key": "check_if_coupon_code_distribution_is_active"
          }
      ],
      "fallback_match_string": "func check_has_coupon_code_cd() == true",
      "key": "check_if_coupon_code_distribution_is_active"
  },
  "check_if_coupon_code_distribution_has_ended": {
      "active": false,
      "prod_active": false,
      "ui_name": "Check if coupon code distribution has ended",
      "action_name": "coupon code distribution has ended",
      "supported_template_types": "normalchat,quickreplies,buttonmessage,carousel,richcard,image,video,document,listreply,contact,location,cancelled,videoreply,botwhatsapptemplate",
      "Condition": [
          {
              "label": "Check if coupon code distribution has ended",
              "condition": "func check_has_coupon_code_cd() == false",
              "key": "check_if_coupon_code_distribution_has_ended"
          }
      ],
      "fallback_match_string": "func check_has_coupon_code_cd() == false",
      "key": "check_if_coupon_code_distribution_has_ended"
  },
  "verify_if_coupon_code_is_valid_or_not": {
      "active": false,
      "prod_active": false,
      "ui_name": "Verify if coupon code is valid or not",
      "action_name": "coupon code is valid",
      "supported_template_types": "normalchat",
      "Condition": [
          {
              "label": "Verify if coupon code is valid or not",
              "condition": "func verify_coupon_code_cd() == true",
              "key": "verify_if_coupon_code_is_valid_or_not"
          }
      ],
      "fallback_match_string": "func verify_coupon_code_cd() == true",
      "key": "verify_if_coupon_code_is_valid_or_not"
  },
  "check_subscription_status": {
    "active": true,
    "prod_active": true,
    "ui_name": "Check the Marketing Opt-in Status of the user",
    "action_name": "check subscription status",
    "supported_template_types": "normalchat,quickreplies,buttonmessage,carousel,richcard,image,video,document,listreply,contact,location,cancelled,videoreply,botwhatsapptemplate,interactivecarousel",
    "Condition": [
      {
        "label": "Check the Marketing Opt-in Status of the user",
        "condition": "func compliance_consent_cd() == FIELD_VALUE",
        "key": "check_subscription_status"
      }
    ],
    "input_fields_required": [
      {
        "name": "FIELD_VALUE",
        "field_type": "dropdown_options",
        "field_options": [
          {
            "label": "Subscribed",
            "value": "opt_in"
          },
          {
            "label": "Unsubscribed",
            "value": "opt_out"
          },
          {
            "label": "No status",
            "value": "no_value"
          }
        ],
        "identifier": "field_value",
        "label": "Marketing Opt-in Status",
        "trim_part1": "func compliance_consent_cd() == ",
        "trim_part2": ""
      },
    ],
    "fallback_match_string": "func compliance_consent_cd(",
    "key": "check_subscription_status"
  },
}

const nodeOperations = {
  "save_user_text_in_variable": {
    "active": true,
    "prod_active": true,
    "ui_name": "Save user response",
    "action_name": "save user response",
    "supported_template_types": "normalchat,quickreplies,buttonmessage,carousel,richcard,listreply,botwhatsapptemplate,interactivecarousel",
    "Operation": [
      {
        "label": "Save the text entered into variable",
        "operation": "order.variables[VARIABLE_NAME] = text",
        "key": "save_user_text_in_variable"
      }
    ],
    "input_fields_required": [
      {
        "name": "VARIABLE_NAME",
        "field_type": "bot_variable",
        "identifier": "variable_name",
        "label": "Enter variable name to store data",
        "trim_part1": "order.variables[",
        "trim_part2": "] = text"
      }
    ],
    "fallback_match_string": "order.variables[",
    "key": "save_user_text_in_variable"
  },
  "add_crm_tags": {
    "active": true,
    "prod_active": true,
    "ui_name": "Add CRM tag",
    "action_name": "add tag",
    "supported_template_types": "normalchat,quickreplies,buttonmessage,carousel,richcard,image,video,document,listreply,contact,location,cancelled,videoreply,botwhatsapptemplate,interactivecarousel",
    "Operation": [
      {
        "label": "Add CRM tag",
        "operation": "func add_tags_op(CUSTOM_TAG)",
        "key": "add_crm_tags"
      }
    ],
    "input_fields_required": [
      {
        "name": "CUSTOM_TAG",
        "field_type": "custom_tag",
        "identifier": "custom_tag",
        "label": "Enter a tag",
        "trim_part1": "func add_tags_op(",
        "trim_part2": ")"
      }
    ],
    "fallback_match_string": "func add_tags_op(",
    "key": "add_crm_tags"
  },
  "remove_crm_tags": {
    "active": true,
    "prod_active": true,
    "ui_name": "Remove CRM tag",
    "action_name": "remove tag",
    "supported_template_types": "normalchat,quickreplies,buttonmessage,carousel,richcard,image,video,document,listreply,contact,location,cancelled,videoreply,botwhatsapptemplate,interactivecarousel",
    "Operation": [
      {
        "label": "Remove CRM tag",
        "operation": "func remove_tags_op(CUSTOM_TAG)",
        "key": "remove_crm_tags"
      }
    ],
    "input_fields_required": [
      {
        "name": "CUSTOM_TAG",
        "field_type": "custom_tag",
        "identifier": "custom_tag",
        "label": "Enter a tag",
        "trim_part1": "func remove_tags_op(",
          "trim_part2": ")"
      }
    ],
    "fallback_match_string": "func remove_tags_op(",
    "key": "remove_crm_tags"
  },
  "create_crm_custom_field": {
      "active": true,
      "prod_active": true,
      "ui_name": "Add/update CRM field",
      "action_name": "add custom_field",
      "supported_template_types": "normalchat,quickreplies,buttonmessage,carousel,richcard,image,video,document,listreply,contact,location,cancelled,videoreply,botwhatsapptemplate,interactivecarousel",
      "Operation": [
          {
              "label": "Add/update CRM field",
              "operation": "func add_customfield_op(FIELD_NAME,FIELD_VALUE)",
              "key": "create_crm_custom_field"
          }
      ],
      "input_fields_required": [
          {
              "name": "FIELD_NAME",
              "field_type": "field_name",
              "identifier": "field_name",
              "label": "Field name",
              "trim_part1": "func add_customfield_op(",
              "trim_part2": ",",
              "canAddNewField": true
          },
          {
              "name": "FIELD_VALUE",
              "field_type": "field_value",
              "identifier": "field_value",
              "label": "Field value",
              "trim_part1": ",",
              "trim_part2": ")"
          }
      ],
      "fallback_match_string": "func add_customfield_op(",
      "key": "create_crm_custom_field"
  },
  "remove_crm_custom_field": {
    "active": true,
    "prod_active": true,
    "ui_name": "Remove CRM field",
    "action_name": "remove custom_field",
    "supported_template_types": "normalchat,quickreplies,buttonmessage,carousel,richcard,image,video,document,listreply,contact,location,cancelled,videoreply,botwhatsapptemplate,interactivecarousel",
    "Operation": [
      {
        "label": "Remove CRM field",
        "operation": "func remove_customfield_op(FIELD_NAME,FIELD_VALUE)",
        "key": "remove_crm_custom_field"
      }
    ],
    "input_fields_required": [
      {
        "name": "FIELD_NAME",
        "field_type": "field_name",
        "identifier": "field_name",
        "label": "Field name",
        "trim_part1": "func remove_customfield_op(",
        "trim_part2": ","
      }
    ],
    "fallback_match_string": "func remove_customfield_op(",
    "key": "remove_crm_custom_field"
  },
  "typing_indicator": {
    "active": true,
    "prod_active": true,
    "ui_name": "Typing indicator",
    "action_name": "typing indicator",
    "supported_template_types": "normalchat,quickreplies,buttonmessage,carousel,richcard,image,video,document,listreply,contact,location,cancelled,videoreply,botwhatsapptemplate,interactivecarousel",
    "Operation": [
      {
        "label": "Show typing indicator",
        "operation": "func delay(SECONDS)",
        "key": "typing_indicator"
      }
    ],
    "input_fields_required": [
      {
        "name": "SECONDS",
        "field_type": "dropdown",
        "field_options": ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"],
        "identifier": "seconds",
        "label": "Select seconds",
        "trim_part1": "func delay(",
        "trim_part2": ")"
      }
    ],
    "fallback_match_string": "func delay(",
    "key": "typing_indicator"
  },
  "ping_live_agent": {
    "active": true,
    "prod_active": true,
    "ui_name": "Ping live chat agent",
    "action_name": "Ping live chat agent",
    "supported_template_types": "normalchat,quickreplies,buttonmessage,carousel,richcard,image,video,document,listreply,contact,location,cancelled,videoreply,botwhatsapptemplate,interactivecarousel",
    "Operation": [
      {
        "label": "Selection of live chat agent / group",
        "operation": "flow.assigntoid = AGENT_OR_GROUP_ID",
        "key": "ping_live_agent_assign"
      },
      {
        "label": "Ping live chat agent / group",
        "operation": "func ping_livechat_op()",
        "key": "ping_live_agent_ping"
      }
    ],
    "input_fields_required": [
      {
        "name": "AGENT_OR_GROUP_ID",
        "field_type": "agent_or_group_selection",
        "identifier": "agent_or_group_id",
        "label": "Select agent / group",
        "trim_part1": "flow.assigntoid = ",
        "trim_part2": ""
      }
    ],
    "fallback_match_string": "flow.assigntoid = ",
    "key": "ping_live_agent"
  },
  "call_3rd_party_api": {
    "active": true,
    "prod_active": true,
    "ui_name": "Call 3rd party API",
    "action_name": "Call 3rd party API",
    "supported_template_types": "normalchat,quickreplies,buttonmessage,carousel,richcard,image,video,document,listreply,contact,location,cancelled,videoreply,botwhatsapptemplate,interactivecarousel",
    "Operation": [
      {
        "label": "To call the provided API",
        "operation": "func callapi(API_ID)",
        "key": "call_3rd_party_api"
      }
    ],
    "fallback_match_string": "func callapi(",
    "key": "call_3rd_party_api"
  },
  "end_flow_and_trasfer_to_another_bot": {
    "active": true,
    "prod_active": true,
    "ui_name": "End this bot & connect to another bot",
    "action_name": "end chatbot flow and transfer to different bot directly",
    "supported_template_types": "normalchat,quickreplies,buttonmessage,carousel,richcard,image,video,document,listreply,contact,location,cancelled,videoreply,botwhatsapptemplate,interactivecarousel",
    "Operation": [
      {
        "label": "Save all of the data mentioned in flow",
        "operation": "order.payment = true",
        "key": "end_flow_and_trasfer_to_another_bot_payment"
      },
      /* {
        "label": "End flow to start a new one",
        "operation": "func doput(order)",
        "key": "end_flow_and_trasfer_to_another_bot_doput"
      }, */
      {
        "label": "Set new bot in context",
        "operation": "func set_force_hashtag_product_op(BOT_LINK)",
        "key": "end_flow_and_trasfer_to_another_bot_force_hashtag"
      },
      {
        "label": "Initialize new order",
        "operation": "func order_init_op()",
        "key": "end_flow_and_trasfer_to_another_bot_order_init"
      },
      {
        "label": "Set order as new bot",
        "operation": "flow.autobot = product",
        "key": "end_flow_and_trasfer_to_another_bot_autobot"
      },
      {
        "label": "Set startpoint of new bot",
        "operation": "func set_autoaction()",
        "key": "end_flow_and_trasfer_to_another_bot_autoaction"
      },
      {
        "label": "Set conversation as active for new bot",
        "operation": "conversation.active = true",
        "key": "end_flow_and_trasfer_to_another_bot_conversation"
      }
    ],
    "input_fields_required": [
      {
        "name": "BOT_LINK",
        "field_type": "bot_link_active",
        "identifier": "bot_trigger",
        "label": "Select a bot",
        "trim_part1": "func set_force_hashtag_product_op(",
        "trim_part2": ")"
      }
    ],
    "fallback_match_string": "func set_force_hashtag_product_op",
    "key": "end_flow_and_trasfer_to_another_bot"
  },
  "update_subscription_status": {
    "active": true,
    "prod_active": true,
    "ui_name": "Update the Marketing Opt-in Status of the user",
    "action_name": "update subscription status",
    "supported_template_types": "normalchat,quickreplies,buttonmessage,carousel,richcard,image,video,document,listreply,contact,location,cancelled,videoreply,botwhatsapptemplate,interactivecarousel",
    "Operation": [
      {
        "label": "Update the Marketing Opt-in Status of the user",
        "operation": "func execute_compliance_op(COMPLAINCE_OPTION)",
        "key": "marketing_compliance"
      }
    ],
    "input_fields_required": [
      {
        "name": "COMPLAINCE_OPTION",
        "field_type": "dropdown_options",
        "field_options": [
          {
            "label": "Subscribed",
            "value": "opt_in"
          },
          {
            "label": "Unsubscribed",
            "value": "opt_out"
          }
        ],
        "identifier": "field_value",
        "label": "Marketing Opt-in Status",
        "trim_part1": "func execute_compliance_op(",
        "trim_part2": ")"
      }
    ],
    "fallback_match_string": "func execute_compliance_op(",
    "key": "marketing_compliance"
  },
  /* "end_flow": {
    "active": false,
    "prod_active": false,
    "ui_name": "End flow",
    "action_name": "end of bot flow",
    "supported_template_types": "normalchat,quickreplies,buttonmessage,carousel,richcard,image,video,document,listreply,contact,location,cancelled,videoreply",
    "Operation": [
      {
        "label": "Save all of the data mentioned in flow",
        "operation": "order.payment = true",
        "key": "end_flow_payment"
      },
      {
        "label": "End flow",
        "operation": "func endchat_op()",
        "key": "end_flow_end_chat"
      }
    ],
    "fallback_match_string": "order.payment = true",
    "key": "end_flow"
  } */
}

const channels = {
  whatsapp: {
    name: 'WhatsApp',
    value: 'whatsapp',
    icon: require('@/resources/images/whatsapp_icon.svg'),
    color: '#FA7554',
    crmKey: 'WhatsApp'
  },
  googlercs: {
    name: 'Google RCS',
    value: 'googlercs',
    icon: require('@/resources/images/Google_RCS_icon.svg'),
    color: '#871EFF',
    crmKey: 'googlercs'
  },
  sms: {
    name: 'SMS',
    value: 'sms',
    icon: require('/src/resources/images/sms_logo.svg'),
    color: '#80C7F5',
    crmKey: 'SMS'
  },
  // TODO: re-enable when email channel is ready [APICC-3735]
  // email: {
  //   name: 'Email',
  //   value: 'email',
  //   icon: require('@/resources/images/email_icon.svg'),
  //   color: '#EA4335',
  //   crmKey: 'Email'
  // }
}

export { botBuilderNodes, channels, nodeOperations, nodeConditions };
